export const KEY = {
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    SPACE: ' ',
}

export const DIRECTION = {
    UP: 'up',
    DOWN: 'down',
}

export const ICON_SIZE = {
    XSMALL: 12,
    SMALL: 16,
    MEDIUM: 24,
    XLARGE: 64
}
